<template>
  <basic-modal
    refs="memberSearch"
    :title="$ts('modal.titles.globalMemberSearch.title')"
    :sub-title="$ts('modal.titles.globalMemberSearch.subTitle')"
  >
    <template slot="modal-data">
      <div class="row">
        <div class="col-12">
          <q-select
            v-model.trim="filter"
            hide-bottom-space
            :label="$ts('fields.labels.searchMember')"
            options-dense
            dense
            outlined
            use-input
            fill-input
            hide-selected
            autofocus
            :options="memberSearchList"
            @filter="search"
          >
            <template v-slot:option="scope">
              <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                <q-item-section>
                  <q-item-label v-html="scope.opt.label" />
                  <q-item-label caption>{{ scope.opt.sublabel }}</q-item-label>
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey">
                  {{ $t('Common.NoResult.Text') }}
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:after>
              <q-btn
                :disable="!filter"
                icon="chevron_right"
                rounded
                unelevated
                color="action-button-success"
                @click="callback"
              />
            </template>
          </q-select>
        </div>
      </div>
    </template>
  </basic-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'MemberSearchModal',
  props: {
    additionalParams: {
      type: Object,
      default: () => ({}),
    },
    useSources: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filter: null,
      memberSearchList: [],
    }
  },
  watch: {
    filter(to) {
      this.$emit('input', to.value)
      this.redemptionModel(to)
    },
  },
  computed: {
    ...mapState({
      membersSearchData: state => state.globalCMP.memberSearchDataGlobal,
    }),
  },
  methods: {
    ...mapActions(['getMemberSearchAction']),
    show() {
      this.openCloseModal({ name: 'memberSearch', status: true })
    },
    search(term, update, abort) {
      if (term !== '') {
        let query = {
          exclude_non_active: false,
          search_text: term,
          limit: 10,
          ...this.additionalParams,
        }
        this.getMemberSearchAction(query)
          .then(() => {
            update(() => {
              this.memberSearchList = this.membersSearchData.list
            })
          })
          .catch(() => {
            abort()
          })
      } else {
        abort()
      }
    },
    callback() {
      this.$emit('callback', this.filter)
      console.log(this.filter)
    },
    redemptionModel(info) {
      if (this.useSources === 'redemption') {
        console.log(info.userID)
      }
    },
  },
}
</script>
